export enum ScreenSize{
    Mobile=500,
    Small=1400,
    Large=2000
}
